<ng-container [ngSwitch]="device?.online">
    <ng-container *ngSwitchCase="true">
        <mat-icon color="accent" [matTooltip]="'DEVICES.CONNECTION.ONLINE' | transloco">wifi</mat-icon>
    </ng-container>
    <ng-container *ngSwitchCase="false">
        <mat-icon class="offline" [matTooltip]="'DEVICES.CONNECTION.OFFLINE' | transloco">wifi</mat-icon>
    </ng-container>
</ng-container>
